import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

export const semesterAll: ApiFunc<`${typeof API.SEMESTER_ALL}`, 'get'> = data =>
  getInstance().get(API.SEMESTER_ALL, {
    params: data,
  })
